import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { apiGet } from "../../services/api/apiClient";

type LoadingStatus = "idle" | "loading" | "succeeded" | "failed";

interface TransactionsState {
  transactions: any[];
  fetchTransactionsStatus: LoadingStatus;
  fetchTransactionsError: string | null;
  filters: {
    transactions: { status: string[] };
  };
}

const initialState: TransactionsState = {
  transactions: [],
  fetchTransactionsStatus: "idle",
  fetchTransactionsError: null,

  filters: {
    transactions: { status: ["0"] },
  },
};

export const fetchTransactions = createAsyncThunk(
  "transactions/fetchTransactions",
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as any;
    const id = state.login.user?.id;

    if (!id) {
      return rejectWithValue("No user found");
    }
    try {
      const data = await apiGet({
        endpoint: "/get-payments",
        params: { userId: id },
        withAuth: true,
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch payments");
    }
  }
);

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    changeTransactionsFilter: (state, action: PayloadAction<{ name: string; value: string[] }>) => {
      state.filters.transactions[action.payload.name as keyof typeof state.filters.transactions] = action.payload.value as any;
    },
    clearTransactionsFilters: (state) => {
      state.filters = {
        transactions: { status: ["0"] },
      };
    },
    clearTransactionsMessages: (state) => {
      state.fetchTransactionsStatus = "idle";
      state.fetchTransactionsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.fetchTransactionsStatus = "loading";
      })
      .addCase(fetchTransactions.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.fetchTransactionsStatus = "succeeded";
        state.transactions = action.payload;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.fetchTransactionsStatus = "failed";
        state.fetchTransactionsError = action.payload as string;
      });
  },
});

export const {
  changeTransactionsFilter,
  clearTransactionsFilters,
  clearTransactionsMessages,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
